import type { RoleTraits } from '@blueshift-ui/analytics/dist/types/role-traits';

function getRoleTraits(labUser: any): RoleTraits {
  switch (labUser.role) {
    case 'client':
      return {
        role_id: labUser.clientId,
        role_uuid: labUser.clientUuid,
      };
    case 'student': {
      const student = labUser.students?.[0];
      return {
        role_id: student?.id ?? labUser.entityId,
        role_uuid: student?.uuid ?? labUser.id,
      };
    }
    case 'tutor':
      return {
        role_id: labUser.tutorId,
        role_uuid: labUser.tutorUuid,
      };
    default:
      return {
        role_id: labUser.entityId,
        role_uuid: labUser.id,
      };
  }
}

export default getRoleTraits;
